import React, { useState, useEffect } from "react";
import styles from "./cta-banner.module.scss";
import { useTranslation } from "lib/i18n/use-translation";
import useFeatureFlags from "../../hooks/use-feature-flags";
import {
  HEALTH_BINGO_FLAG,
  HEALTH_BINGO_END,
  getHealthBingoUrl,
} from "../health-bingo/constants";

const REVEAL_DELAY_MS = 500;

const CtaBanner = () => {
  const { isEnabled, loading } = useFeatureFlags();
  const { t } = useTranslation(["components", "home"]);
  const [dismissed, setDismissed] = useState(false);
  const [visible, setVisible] = useState(false);

  const shouldShow =
    !loading &&
    !dismissed &&
    new Date() < HEALTH_BINGO_END &&
    isEnabled(HEALTH_BINGO_FLAG);

  useEffect(() => {
    if (!shouldShow) return;
    const timer = setTimeout(() => setVisible(true), REVEAL_DELAY_MS);
    return () => clearTimeout(timer);
  }, [shouldShow]);

  if (!shouldShow || !visible) {
    return null;
  }

  const handleDismiss = () => setDismissed(true);

  return (
    <div className={styles["cta-banner"]}>
      <p className={styles["cta-banner-text"]}>{t("home:healthBingo.title")}</p>
      <a
        className={styles["cta-banner-link"]}
        href={getHealthBingoUrl()}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t("home:healthBingo.takeMeThere")}
      </a>
      <button
        className={styles["cta-banner-dismiss"]}
        onClick={handleDismiss}
        aria-label={t("components:ctaBanner.dismissA11y")}
      >
        {"✕"}
      </button>
    </div>
  );
};

export default CtaBanner;
